import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import moment from 'moment'
import { useTranslation } from '@morningtrain/react-translations'

export default function HumanizedDuration ({
  name,
  defaultValue = null
}) {
  const value = useValue(name, defaultValue)

  let days = value
  const years = parseInt(days / 365)

  const fragments = []

  if (years > 0) {
    const yearsInDays = years * 365
    days = days - yearsInDays
    fragments.push(moment.duration(yearsInDays, 'days').humanize())
  }

  fragments.push(moment.duration(days, 'days').humanize({ M: 120 }))

  const transAnd = useTranslation('generic.and')

  return fragments.join(` ${transAnd} `)
}
